import styled from 'styled-components';

import { space3XL } from '@xing-com/tokens';

const LoadingStateContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  padding: ${space3XL} 0;
`;

export const Styled = { LoadingStateContainer };
